/* eslint-disable no-param-reassign */
<template>
  <div class="account">
    <PageSubHeader :pageSubHeader="pageSubHeader" />

    <main>
      <section id="form_detail">
        <div class="w1300">

          <!-- 表單主標題 -->
          <div class="form_main_title_box">
            <h3 class="form_main_title txt-bold">費用查詢</h3>
            <div class="img_box">
              <img src="@/statics/img/index/icon_title2.svg" alt="">
            </div>
          </div>

          <form id="form_account_search_fee" @submit.prevent>

            <div
              class="filter_box payment_status"
              style="display: flex; justify-content: space-between; align-items: center;"
            >
              <select
                id="payment_status"
                name="payment_status"
                v-model="params.pay_status"
                @change="filterData()"
              >
                <option value="" disabled selected>篩選繳費狀態</option>
                <option value="-1">全部</option>
                <option value="0">未繳費</option>
                <option value="1">已繳費</option>
                <option value="2">作廢</option>
              </select>

              <button
                v-if="user.is_permanent === 0"
                type="button"
                class="btn account-search-fee__upgrade-btn"
                @click="onUpgradePermanent"
              >
                升級永久會員 ($20,000)
              </button>
              <span v-else-if="user.is_permanent === 1" class="txt-bold txt-light_green">
                您是永久會員
              </span>
            </div>

            <!-- table area -->
            <div class="table_box">

              <table class="txt-center">
                <thead>
                  <tr>
                    <th class="td-main txt-left"><p>{{ th1 }}</p></th>
                    <th class="min100"><p>{{ th2 }}</p></th>
                    <th class="min100"><p>{{ th3 }}</p></th>
                    <th class="min150"><p>{{ th4 }}</p></th>
                    <th class="min100"><p>{{ th5 }}</p></th>
                    <th class="min100"><p>{{ th6 }}</p></th>
                  </tr>
                </thead>
                <tbody id="table_data">
                  <tr v-for="tr in tableData" :key="tr.id">
                    <td :data-title="th1" class="td-main txt-left">
                      <p v-for="item in tr.order_details" :key="item.uuid">
                        {{ item.content }}
                      </p>
                    </td>
                    <td :data-title="th2"><p>{{ tr.year }}</p></td>
                    <td :data-title="th3"><p>{{ tr.total }}</p></td>
                    <td :data-title="th4" class="td-input">
                      <p v-for="item in tr.order_details" :key="item.uuid">
                        {{ item.title }}
                      </p>
                    </td>
                    <td :data-title="th5" class="min100"><p>{{ statusConverter(tr) }}</p></td>
                    <td :data-title="th6" class="td-download-multiple">
                      <template v-if="canDownloadReceipt(tr)">
                        <button
                          v-for="item in tr.order_details"
                          :key="item.uuid"
                          type="button"
                          class="small"
                          @click="updateReceiptInfo(item.uuid)"
                        >下載收據</button>
                      </template>
                      <template v-else-if="canPay(tr)">
                        <button
                          type="button"
                          class="small payment_fail_btn"
                          @click="goToPay(tr)"
                        >前往繳費</button>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </form>
        </div>

        <Pagination
          :pageButton="pageButton"
          :page="params.page"
          :totalPage="totalPage"
          @updatePage="updatePage"
        />
      </section>
    </main>
  </div>
</template>

<script>
// Library
import _ from 'lodash';

// Components
import PageSubHeader from '@/components/PageSubHeader.vue';
import Pagination from '@/components/Pagination.vue';

// Functions
import { AccountSearchSubHeader } from '@/lib/const';
import {
  orderList,
  downloadReceipt,
  userInfo,
  upgradePermanent,
} from '@/lib/http';

export default {
  name: 'AccountSearchFee',
  data() {
    return {
      /** Static Data */
      ...AccountSearchSubHeader,
      pageButton: 5,
      th1: '費用名稱',
      th2: '年度',
      th3: '金額',
      th4: '收據抬頭',
      th5: '繳費狀態',
      th6: '操作',

      /** Search Params */
      params: {
        pay_status: '',
      },

      /** Axios Data */
      user: {},
      totalPage: 1,
      tableData: [],
    };
  },
  created() {
    userInfo().then((res) => {
      this.user = res;
    });
    if (this.$route.query.pay_status) {
      this.params.pay_status = this.$route.query.pay_status;
    }
    if (this.$route.query.num) {
      this.params.page = Number.parseInt(this.$route.query.num, 10);
    }
    this.filterDataInit(this.params.page);
  },
  methods: {
    shouldFilterByStatus() {
      const payStatus = Number.parseInt(this.params.pay_status, 10);
      return payStatus === 0 || payStatus === 1 || payStatus === 2;
    },
    statusConverter(order) {
      if (this.isVoided(order)) {
        return '作廢';
      }
      if (_.get(order, 'payment.completed', null)) {
        return '已繳費';
      }
      return '未繳費';
    },
    isVoided(order) {
      return _.get(order, 'deleted', null) !== null;
    },
    canDownloadReceipt(order) {
      return this.statusConverter(order) === '已繳費';
    },
    canPay(order) {
      return this.statusConverter(order) === '未繳費';
    },
    /** 收據資料存進cookies */
    updateReceiptInfo(uuid) {
      downloadReceipt({
        order_detail_uuid: uuid,
      }).then((result) => {
        if (result.data.status) {
          this.$cookies.set('receiptInfo', JSON.stringify(result.data.result.data));
          const routeData = this.$router.resolve({ path: '/receipt' });
          window.open(routeData.href, '_blank');
        } else {
          this.openModal({
            message: result.data.message,
          });
        }
      });
    },
    goToPay(data) {
      const orderID = _.get(data, 'uuid', '');
      if (orderID) {
        this.$router.push({ path: `/account/search/payment?order_id=${orderID}` });
      } else {
        this.openModal({
          message: '尚未產生未繳費訂單',
        });
      }
    },
    filterDataInit(pageValue = 1) {
      if (this.shouldFilterByStatus()) {
        orderList({
          ...this.params,
          page: pageValue,
        }).then((result) => {
          if (result.data.status) {
            this.tableData = result.data.result.data;
            this.totalPage = result.data.result.pageCount;
            this.params.page = pageValue;
            this.$router.replace({
              query: {
                pay_status: this.params.pay_status,
                num: pageValue,
              },
            });
          }
        });
      } else {
        orderList({
          page: pageValue,
        }).then((result) => {
          if (result.data.status) {
            this.tableData = result.data.result.data;
            this.totalPage = result.data.result.pageCount;
            this.params.page = pageValue;
            this.$router.replace({
              query: {
                pay_status: this.params.pay_status,
                num: pageValue,
              },
            });
          }
        });
      }
    },
    filterData(pageValue = 1) {
      if (this.shouldFilterByStatus()) {
        orderList({
          ...this.params,
          page: pageValue,
        }).then((result) => {
          if (result.data.status) {
            this.tableData = result.data.result.data;
            this.totalPage = result.data.result.pageCount;
            this.params.page = pageValue;
            this.$router.push({
              query: {
                pay_status: this.params.pay_status,
                num: pageValue,
              },
            });
          }
        });
      } else {
        orderList({
          page: pageValue,
        }).then((result) => {
          if (result.data.status) {
            this.tableData = result.data.result.data;
            this.totalPage = result.data.result.pageCount;
            this.params.page = pageValue;
            this.$router.push({
              query: {
                pay_status: this.params.pay_status,
                num: pageValue,
              },
            });
          }
        });
      }
    },
    updatePage(value) {
      this.filterData(value);
    },
    onUpgradePermanent() {
      this.$store.dispatch('openModal', {
        message: '確認要升級永久會員嗎？<br>申請後將產生一筆 $20,000 的繳費單。',
        btnType: 'confirm',
      }).then((confirm) => {
        if (confirm) {
          upgradePermanent().then((res) => {
            if (res.data.status) {
              const orderUUID = res.data.result.order.uuid;
              this.$cookies.set('applicationPayment', {
                order_uuid: orderUUID,
                detail: [{
                  uuid: res.data.result.order.order_details[0].uuid,
                  title: this.user.realname,
                }],
              });
              this.$router.push({ path: '/application/payment' });
            } else {
              this.$store.dispatch('openModal', {
                message: res.data.message,
              });
            }
          });
        }
      });
    },
  },
  watch: {
    /**
     * 偵測user使用網頁的上一頁功能時，重設頁數及重call API
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      const queryNum = Number.parseInt(this.$route.query.num, 10);
      if (queryNum && queryNum > 0) {
        this.params.page = Number.parseInt(this.$route.query.num, 10);
        this.filterData(this.params.page);
      }
    },
  },
  components: {
    PageSubHeader,
    Pagination,
  },
};
</script>

<style scoped>
.account-search-fee__upgrade-btn {
  padding: 10px 20px;
  background-color: #ffd08a;
  color: #3d2200;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
</style>
